export default {
  namespaced: true,
  state: {
    experienceScoreData: [], // 质检得分
    qualityTabs: 'first', // 服务质检切换值
    tableConfig: {},
    customRaceQuality: [], // 是否显示指标趋势统计
    qualityMsgCode: undefined, // 商圈质检可配置
    qcDetailMsgCode: undefined, // 服务质检无数据
    bizAreaRankCode: undefined,
    bizAreaRankTrendCode: undefined,
    commentAnalysisCode: undefined,
    commentAnalysisDetailCode: undefined,
    experienceScoreCode: undefined,
  },
  mutations: {
    SET_EXPERIENCE_SCORE_CODE(state, experienceScoreCode) {
      state.experienceScoreCode = experienceScoreCode
    },
    SET_COMMENT_ANALYSIS_DETAIL_CODE(state, commentAnalysisDetailCode) {
      state.commentAnalysisDetailCode = commentAnalysisDetailCode
    },
    SET_COMMENT_ANALYSIS_CODE(state, commentAnalysisCode) {
      state.commentAnalysisCode = commentAnalysisCode
    },
    SET_BIZ_AREA_RANK_Trend_CODE(state, bizAreaRankTrendCode) {
      state.bizAreaRankTrendCode = bizAreaRankTrendCode
    },
    SET_BIZ_AREA_RANK_CODE(state, bizAreaRankCode) {
      state.bizAreaRankCode = bizAreaRankCode
    },
    SET_QC_DETAILMSGCODE(state, qcDetailMsgCode) {
      state.qcDetailMsgCode = qcDetailMsgCode
    },
    SET_QUALITY_MSGCODE(state, qualityMsgCode) {
      state.qualityMsgCode = qualityMsgCode
    },
    SET_CUSTOM_RACE_QUALITY(state, customRaceQuality) {
      state.customRaceQuality = customRaceQuality
    },
    SET_TABLE_CONFIG(state, tableConfig) {
      state.tableConfig = tableConfig
    },
    SET_QUALITY_TABS(state, qualityTabs) {
      state.qualityTabs = qualityTabs
    },
    SET_EXPERIENCE_SCORE(state, experienceScoreData) {
      state.experienceScoreData = experienceScoreData
    },
  },
}
